import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import data from "../../data/product.json";
import PortfolioOne from "./PortfolioOne";
import Spacer4 from "../common/Spacer4";

function KayarOtomat() {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <SRLWrapper>
      <main>

        {/* =====================================================
            CNC KAYAR OTOMAT
        ===================================================== */}

        <Spacer4/>

        <section
          id="kayar-otomat"
          aria-labelledby="kayar-otomat-title"
          style={{
            paddingTop: "70px",
            paddingBottom: "35px",
            background: "#ffffff",
          }}
        >
          <Container>

            {/* ANA BAŞLIK */}

            <div
              className="text-center"
              data-aos="fade-up"
              style={{
                marginBottom: "45px",
              }}
            >
              <h1
                id="kayar-otomat-title"
                style={{
                  fontSize: "clamp(30px, 4vw, 46px)",
                  fontWeight: "600",
                  color: "#444",
                  marginBottom: "15px",
                }}
              >
                {t("CNC Kayar Otomat ve Talaşlı İmalat")}
              </h1>

              <div
                style={{
                  width: "70px",
                  height: "3px",
                  background: "#0000ff",
                  margin: "0 auto",
                }}
              />
            </div>


            {/* =====================================================
                HİZMET ALANI
            ===================================================== */}

            <Row
              className="align-items-center"
              data-aos="fade-up"
            >

              {/* AÇIKLAMA */}

              <Col lg={6}>
                <div
                  style={{
                    padding:
                      "clamp(10px, 2vw, 30px)",
                  }}
                >
                  <h2
                    style={{
                      fontSize:
                        "clamp(25px, 3vw, 34px)",
                      fontWeight: "600",
                      color: "#444",
                      marginBottom: "20px",
                    }}
                  >
                    {t("CNC Kayar Otomat")}
                  </h2>

                  <p
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.8",
                      color: "#666",
                      marginBottom: "15px",
                    }}
                  >
                    {t("KayarOtomat.Para1")}
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.8",
                      color: "#666",
                      marginBottom: "15px",
                    }}
                  >
                    {t("KayarOtomat.Para2")}
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.8",
                      color: "#666",
                      marginBottom: "25px",
                    }}
                  >
                    {t("KayarOtomat.Para3")}
                  </p>


                  {/* TEKLİF BUTONU */}

                  <Link
                    to="/iletisim"
                    onClick={scrollToTop}
                    aria-label={t(
                      "CNC kayar otomat için teklif al"
                    )}
                    style={{
                      display: "inline-block",
                      background: "#0000ff",
                      color: "#ffffff",
                      padding: "12px 30px",
                      borderRadius: "4px",
                      fontSize: "15px",
                      fontWeight: "600",
                      textDecoration: "none",
                      transition: "0.3s",
                    }}
                  >
                    {t("Teklif Al")}
                  </Link>
                </div>
              </Col>

              {/* GÖRSEL */}

              <Col
                lg={6}
                className="mb-4 mb-lg-0"
              >
                <div
                  style={{
                    paddingRight: "15px",
                  }}
                >
                  <img
                    src="/assets/img/Aypinautomat/sliderorj1.webp"
                    alt={t(
                      "CNC Kayar Otomat ve Talaşlı İmalat"
                    )}
                    title={t(
                      "CNC Kayar Otomat ve Talaşlı İmalat"
                    )}
                    className="img-fluid"
                    loading="eager"
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </Col>


              

            </Row>
          </Container>
        </section>


        {/* =====================================================
            ÜRÜNLER
        ===================================================== */}

        <section
          id="urunlerimiz"
          className="portfolio"
          aria-labelledby="products-title"
          style={{
            paddingTop: "40px",
            paddingBottom: "40px",
            background: "#ffffff",
          }}
        >
          <Container>

            {/* ÜRÜNLERİMİZ BAŞLIK */}

            <div
              className="section-title"
              data-aos="fade-up"
              style={{
                marginBottom: "35px",
              }}
            >
              <h2 id="products-title">
                {t("ÜRÜNLERİMİZ")}
              </h2>
            </div>


            {/* ÜRÜN KARTLARI */}

            <Row>
              {data.map((product) => {

                const {
                  picture,
                  nav,
                  id,
                } = product;

                const title =
                  t(product.title);

                const desc =
                  t(product.desc);

                return (
                  <Col
                    lg={3}
                    md={6}
                    sm={12}
                    key={id}
                    className="text-center mb-4"
                  >
                    <PortfolioOne
                      picture={picture}
                      title={title}
                      desc={desc}
                      nav={nav}
                    />
                  </Col>
                );
              })}
            </Row>

          </Container>
        </section>

      </main>
    </SRLWrapper>
  );
}

export default KayarOtomat;